import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite } from '../../../../../../openapi';

@Injectable()
export class IrspaLetterContentForm extends AppForm {
  constructor() {
    super({
      isPropertyOwnerOrPerpetualUser: new FormControl(true, { nonNullable: true, validators: [Validators.required] }),
      shipmentContent: new FormControl(null, [Validators.required, Validators.maxLength(5000)])
    });
  }

  public get geometry(): FormControl | null {
    return this.get('geometry') as FormControl | null;
  }

  public createGeometryControl(): void {
    this.addControl('geometry', new FormControl(null, { validators: [] }));
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      ...value,
      geometry: value?.geometry ? JSON.parse(value?.geometry) : null
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      shipmentContent: this.value.shipmentContent,
      isPropertyOwnerOrPerpetualUser: this.value.isPropertyOwnerOrPerpetualUser,
      geometry: this.geometry?.value ? JSON.stringify(this.geometry.value) : undefined
    };
  }
}
